import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from '../../components/TemplateDashboard';
import AlertNotificaciones from '../../components/AlertNotificaciones/AlertNotificaciones';
import CargaTutoresContent from './components/CargaTutoresContent';

const CargaTutores = () => {

    return (
        <>

            <TemplateDashboard>
                <AlertNotificaciones />
                <CargaTutoresContent />
            </TemplateDashboard>

        </>
    )
};

export default CargaTutores;